/**
 * Auth Data Helpers
 *
 * Utilities for extracting and managing authentication data for redirects
 */

/**
 * Get authentication cookies for cross-origin redirect
 * @returns {Object} - Object with token and user data
 */
export const getAuthDataForRedirect = () => {
  try {
    // Get access token from cookie
    const tokenMatch = document.cookie
      .split("; ")
      .find((row) => row.startsWith("access_token="));
    const token = tokenMatch
      ? decodeURIComponent(tokenMatch.split("=")[1])
      : null;

    // Get user data from cookie
    const userMatch = document.cookie
      .split("; ")
      .find((row) => row.startsWith("user_data="));
    const userData = userMatch
      ? decodeURIComponent(userMatch.split("=")[1])
      : null;

    // Fallback: Try to get from localStorage (since main website also saves there)
    if (!token || !userData) {
      const lsToken = localStorage.getItem("token");
      const lsUser = localStorage.getItem("user_data");

      return {
        token: token || lsToken,
        userData: userData || lsUser,
      };
    }

    return { token, userData };
  } catch (error) {
    console.error("Error getting auth data for redirect:", error);
    return { token: null, userData: null };
  }
};
